import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren, inject } from '@angular/core';
import { LoadingPanelComponent } from '../../core/panels/loading-panel.component';
import { ColumnComponent } from '../../core/table/column.component';
import { TableComponent } from '../../core/table/table.component';
import { StatusHistoryExportMapper } from '../../../utilities/status-history-mapper';
import { DatePipe } from '@angular/common';
import { ExportService } from '../../../services/export/export.service';
import { ExportFormat } from '../../core/buttons/export-button.component';
import { ClaimRow } from '../../../models/api/view/claim-view/claim-row';
import { ClaimInfoStatusHistory } from '../../../models/api/view/claim/header/claiminfostatushistory';
import { BaseComponent } from '../../base/base.component';
import { HandleLoadingState } from '../../../decorators/handle-loading-state.decorator';

@Component({
  selector: 'app-status-history',
  imports: [LoadingPanelComponent, TableComponent, ColumnComponent],
  template: ` <app-loading-panel [state]="loading ? 'Loading' : 'Loaded'" [error]="error">
    <ng-template #loaded>
      <app-table
        #table
        [dataSource]="dataSource"
        [pageSize]="5"
        [recordLabel]="'history record'"
        [recordLabelPlural]="'history records'"
        [showExport]="true"
        [sortField]="'dateStat'"
        [sortOrder]="1"
        (export)="onExport($event)"
        [error]="error"
      >
        <app-column
          name="dateStat"
          label="Status date"
          width="15%"
          format="d"
        />
        <app-column name="changedBy" label="Changed by" width="15%" />
        <app-column name="clmStatus" label="Status" width="15%" />
        <app-column name="subStatusDesc" label="Substatus" width="15%" />
        <app-column name="reopenFlag" label="Reopened" width="15%" format="b" />
        <app-column name="reasonCodes" label="Reason codes" width="25%" />
      </app-table>
    </ng-template>
  </app-loading-panel>`,
  styles: [],
})
export class StatusHistoryComponent extends BaseComponent implements OnInit {
  private datePipe = inject(DatePipe);
  exportService = inject(ExportService);

  @Input()
  dataSource: any[] = [];

  @ViewChild('table')
  table: TableComponent;

  @ViewChildren(ColumnComponent)
  columnsList: QueryList<ColumnComponent>;

  claimRow: ClaimRow;
  statusHistory: ClaimInfoStatusHistory[] = [];
  loading = false;
  error: any = null;

  @HandleLoadingState({ errorProperty: 'actionError' })
  async onExport(format: ExportFormat) {
    const rows = this.table?.dataSource;
    const columns = this.columnsList.toArray();
    const formattedDate = this.datePipe.transform(new Date(), 'yyyyMMddHHmm');
    const filename = `StatusHistory_${formattedDate}.${format}`;

    if (format === 'csv') {
      const csvData = StatusHistoryExportMapper.toCsvExport(
        rows,
        columns,
        'Status History',
      );
      await this.exportService.exportCsv(csvData, filename);
    } else if (format === 'xlsx') {
      const excelData = StatusHistoryExportMapper.toExcelExport(
        rows,
        columns,
        'Status History',
        'Status History Export',
      );
      await this.exportService.exportExcel(excelData, filename);
    }
  }

  @HandleLoadingState()
  async ngOnInit(): Promise<void> {
    this.claimRow = this.view.currentClaim();
    this.dataSource = await this.api.claimHeader.getStatusHistory(
      this.claimRow.recordSource,
      this.claimRow.recordId,
    );
  }
}
